var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessigeIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 71,
    viewBox: "0 0 201 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    width: 81,
    height: 20,
    rx: 10,
    fill: "#E2E6E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 38,
    width: 200,
    height: 13,
    rx: 6.5,
    fill: "#E2E6E9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 59,
    width: 81,
    height: 12,
    rx: 6,
    fill: "#E2E6E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessigeIc);
export default __webpack_public_path__ + "static/media/messige_ic.df8a9e78.svg";
export { ForwardRef as ReactComponent };